import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../utilities/axiosInstance";
import { filterRequest } from "../../utilities/apiManager";

let initialState = {
  isLoading: false,
  data: [],
  transferDetails: null,
  itemsCount: 0,
  pages: 0,
  error: null
}

export const getTransfers = createAsyncThunk(
  "transfers/getTransfers",
  async (args, thunkApi) => {
    try {
      let url = `/dyarko-transactions?`;
      const params = new URLSearchParams();

      if (args.page) params.append('page', args.page);
      if (args.owner) params.append('owner', args.owner);
      if (args.size) params.append('size', args.size);
      if (args.query) params.append('query', args.query);

      const filter = args.filter ? filterRequest(args.filter) : '';

      const { data } = await axiosInstance.get(
        `${url}${params.toString()}${filter}`
      );
      return thunkApi.fulfillWithValue(data);
    } catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const createTransfer = createAsyncThunk(
  "transfers/createTransfer",
  async (args, thunkApi) => {
    try {
      const { data } = await axiosInstance.post(
        `/dyarko-transactions`,
        {
          image: args.image,
          amount: args.amount,
          owner: args.owner,
          transactionNumber: args.transactionNumber,
        }
      );
      return thunkApi.fulfillWithValue({ data });
    }
    catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const updateTransfer = createAsyncThunk(
  "transfers/updateTransfer",
  async (args, thunkApi) => {
    try {
      const { data } = await axiosInstance.put(
        `/transfers/${args._id}`,
        args.values,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          }
        }
      );
      return thunkApi.fulfillWithValue(data);
    }
    catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const deleteTransfer = createAsyncThunk(
  "transfers/deleteTransfer",
  async (args, thunkApi) => {
    try {
      const { data } = await axiosInstance.delete(
        `/transfers/${args._id}`
      );
      return thunkApi.fulfillWithValue(data);
    }
    catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

const transfersSlice = createSlice({
  name: "transfers",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getTransfers.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getTransfers.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data = payload.data.data;
        state.itemsCount = payload.data.itemsCount;
        state.pages = payload.data.pages;
        state.error = null;
      })
      .addCase(getTransfers.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message
      })

      .addCase(createTransfer.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createTransfer.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.error = null;
      })
      .addCase(createTransfer.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })

      .addCase(updateTransfer.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateTransfer.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        const indexAt = state.data.findIndex(el => el._id === payload.data._id);
        state.data[indexAt] = payload.data;
        state.error = null;
      })
      .addCase(updateTransfer.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })

      .addCase(deleteTransfer.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(deleteTransfer.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data = state.data.filter(el => el._id !== payload.data._id);
        state.error = null;
      })
      .addCase(deleteTransfer.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })
  }
});

export default transfersSlice.reducer;